import { Paper, Stack, Typography } from '@mui/material';
import React from 'react';

type PageContainerProps = {
  title: string;
  badgeCount?: number;
};

const PageContainer = ({ title, badgeCount, children }: React.PropsWithChildren<PageContainerProps>) => {
  return (
    <Paper sx={{ padding: 4, paddingBottom: 20, minHeight: '100%' }} elevation={1}>
      <Stack spacing={4}>
        <Stack direction="row" alignItems="center" gap={2}>
          <Typography variant="h2">{title}</Typography>
          {!!badgeCount && badgeCount > 0 && (
            <Stack
              alignItems="center"
              justifyContent="center"
              bgcolor="error.main"
              borderRadius="9px"
              minWidth={18}
              paddingX="5px"
              height={18}
            >
              <Typography color="white" variant="caption">
                {badgeCount <= 9 ? badgeCount : '9+'}{' '}
              </Typography>
            </Stack>
          )}
        </Stack>
        {children}
      </Stack>
    </Paper>
  );
};

export default PageContainer;
